import React, { memo, useCallback } from 'react'
import { ThemeProvider } from '@material-ui/core'
import { getSectionTheme } from '@v4/utils/theme'
import { useSectionMetaData } from '@v4/components/common/SectionItem'
import PropTypes from 'prop-types'

const PrimaryThemeProvider = ({ children }) => {
	const metaData = useSectionMetaData()
	const primaryColor = metaData.primary?.metaValue

	const theme = useCallback(
		parentTheme => {
			return getSectionTheme(parentTheme, {
				palette: {
					primary: primaryColor,
				},
			})
		},
		[primaryColor],
	)
	return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}

PrimaryThemeProvider.propTypes = {
	children: PropTypes.node.isRequired,
}

export default memo(PrimaryThemeProvider)
